import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import NotFound from "notFound/NotFound";
import PageHeader from "common/PageHeader";
import TTPPaginator from "common/list/TTPPaginator";
import CampaignList from "campaign/list/CampaignList";
import CampaignListFilter from "campaign/list/CampaignListFilter";
import {
  setCurrentNavPage,
  setEmailPaginationPage,
  initCampaignListFilter,
  initCampaignListItems,
} from "actions";
import { fetchCampaigns } from "thunks";

import _ from "i18n";

const CampaignListPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const campaigns = useSelector((state) => state.campaigns.list);
  const paginationPage = useSelector(
    (state) => state.campaigns.list.emailPaginationPage,
  );
  const pageSize = useSelector((state) => state.campaigns.list.emailPageSize);
  const filter = useSelector((state) => state.campaigns.list.filter);
  const currentNavPage = useSelector((state) => state.params.currentNavPage);

  const handleFetchCampaigns = useCallback(() => {
    dispatch(fetchCampaigns()).catch((error) => {
      console.error("Error fetching campaigns:", error);
    });
  }, [dispatch]);

  useEffect(() => {
    dispatch(setCurrentNavPage("CAMPAIGN_LIST"));
    handleFetchCampaigns();
  }, [dispatch, handleFetchCampaigns]);

  useEffect(() => {
    handleFetchCampaigns();
  }, [filter, paginationPage, pageSize]);

  useEffect(() => {
    if (currentNavPage !== "CREATE_CAMPAIGN") {
      dispatch(initCampaignListFilter());
      dispatch(initCampaignListItems());
      handleFetchCampaigns();
    }
  }, [currentNavPage]);

  const handleCampaignListPageChange = ({ selected }) => {
    dispatch(setEmailPaginationPage(selected + 1));
  };

  const renderPaginate = () => {
    if (campaigns.error && campaigns.error.code === 404) {
      return null;
    }

    return (
      <TTPPaginator
        onPageChange={handleCampaignListPageChange}
        pageSize={pageSize}
        nbResult={campaigns.nbResult}
        paginationPage={paginationPage}
      />
    );
  };

  return (
    <div className="campaign">
      <div className="grid-container fluid">
        <PageHeader
          header="list of campaigns"
          subHeader="Create, manage and send your email campaigns ."
          icon="EMAIL"
        >
          <button
            className="btn secondary text-uppercase"
            onClick={() => navigate("/campaign/selector")}
          >
            <img src="img/icons/add.svg" alt="Create" />
            {_("create")}
          </button>
        </PageHeader>

        <CampaignListFilter />

        {campaigns.error && campaigns.error.code === 404 ? (
          <NotFound />
        ) : (
          <div
            className={`row expanded m-t-s`}
            style={{ position: "relative", zIndex: "0" }}
          >
            <CampaignList campaigns={campaigns} />
          </div>
        )}

        {!campaigns.fetching && (
          <div className="row align-center margin-bottom-2">
            <div className="column medium-11">{renderPaginate()}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CampaignListPage;
